import { render, staticRenderFns } from "./packageMsg.vue?vue&type=template&id=75a96f18&scoped=true"
import script from "./packageMsg.vue?vue&type=script&lang=js"
export * from "./packageMsg.vue?vue&type=script&lang=js"
import style0 from "./packageMsg.vue?vue&type=style&index=0&id=75a96f18&prod&lang=scss"
import style1 from "./packageMsg.vue?vue&type=style&index=1&id=75a96f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a96f18",
  null
  
)

export default component.exports